import React from "react";
import styles from "./CloseDialog.module.css";
import PropTypes from "prop-types";
import classNames from "classnames";

import RadioButtonGroup from "../RadioButtonGroup";
import Button from "../Button";

/**
 * Interactive component.
 * A dialog that allows the user to select the sort criteria of feeds.
 */
export function CloseDialog({
  sortOptions,
  selectedOption,
  setSelectedOption,
  buttonText,
  headerText,
  buttonClick,
  isOpen,
}) {
  return (
    <div
      className={classNames(styles.blur, {
        [styles.hidden]: !isOpen,
      })}
    >
      <div className={styles.container}>
        <p>{headerText}</p>
        <RadioButtonGroup
          className={styles.buttonText}
          orientation="vertical"
          currentlySelected={selectedOption}
          setCurrentlySelected={(value) => {
            // if (selectedOption !== value) {
              setSelectedOption(value);
            // }
          }}
          options={sortOptions}
        />
        <Button
          text={buttonText}
          onClick={buttonClick}
          className={styles.button}
        />
      </div>
    </div>
  );
}

CloseDialog.propTypes = {
  /**
   * An array of radio button values.
   */
  sortOptions: PropTypes.arrayOf(PropTypes.string),
  /**
   * The value of the currently selected radio button.
   */
  selectedOption: PropTypes.string,
  /**
   * Function that sets the value of the selectedOption prop.
   */
  setSelectedOption: PropTypes.func,
  /**
   * Text of the dismiss button.
   */
  buttonText: PropTypes.string,
  /**
   * Optional text for the dialog header.
   */
  headerText: PropTypes.string,
  /**
   * Function that fires when the dismiss button is clicked.
   */
  buttonClick: PropTypes.func,
  /**
   * Boolean that determines if the dialog is visible.
   */
  isOpen: PropTypes.bool,
};

CloseDialog.defaultProps = {
  sortOptions: [],
  selectedOption: "",
};
